import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const subscription = createApi({
  reducerPath: "subscription",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["subscription"],
  endpoints: (builder) => ({
    getsubscription: builder.query({
      query: ({id}) =>
        `/api/subscription/user/${id}`,
      providesTags: ["subscription"],
    }),

    createsubscription: builder.mutation({
      query: (data) => ({
        url: `/api/subscription/create`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["subscription"],
    }),

    cencelSubsciption: builder.mutation({
      query: ({id}) => ({
        url: `/api/subscription/cancel/${id}`, // Send the `id` as a query parameter
        method: "DELETE", // Or DELETE if your backend expects DELETE
      }),
      invalidatesTags: ["subscription"],
    }),

    updatesubscription: builder.mutation({
      query: (data) => ({
        url: `/api/subscription/change-plan`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["subscription"],
    }),
  }),
});

export const {
  useGetsubscriptionQuery,
  useCreatesubscriptionMutation,
  useCencelSubsciptionMutation,
  useUpdatesubscriptionMutation,
} = subscription;
